var handle_array = ["body-temperature-kiosk-with-facial-recognition"];
 var hide_price=1;
 var hide_ajaxaddtocart =1;
 var display_phone = 1;
 var phone_no='1(805)733-2060';
 var display_call_for_price=1;
 var call_for_price_label = 'Call for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
 var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
 var enable_outofstock = 1;
 var price_selector='.productForm-select';
 var cart_selector='#AddToCart-product-template, .productForm-select';
 var phone_no_label = 'Call /Email us for Prices; inquiry@omieralabs.com or call';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
